document.documentElement.classList.remove('no-js');

async function loadLazyCollectionTab(panel) {
  if (!panel || !panel.matches('[data-lazy-tab-panel]') || panel.dataset.loaded === 'true' || panel.dataset.loading === 'true') return;
  const collectionUrl = panel.dataset.collectionUrl;
  const grid = panel.querySelector('[data-tab-product-grid]');
  if (!collectionUrl || !grid) return;
  panel.dataset.loading = 'true';
  grid.setAttribute('aria-busy', 'true');
  try {
    const separator = collectionUrl.includes('?') ? '&' : '?';
    const response = await fetch(collectionUrl + separator + 'section_id=lazy-collection-products', { headers: { 'Accept': 'text/html' } });
    if (!response.ok) throw new Error('Unable to load collection');
    const html = document.createElement('div');
    html.innerHTML = await response.text();
    const rendered = html.querySelector('[data-lazy-collection-products]');
    if (!rendered) throw new Error('Collection products were not returned');
    const limit = Math.max(1, Number(panel.dataset.productLimit) || 20);
    const cards = Array.from(rendered.querySelectorAll('.product-card'));
    cards.slice(limit).forEach((card) => card.remove());
    grid.innerHTML = rendered.innerHTML;
    panel.dataset.loaded = 'true';
  } catch (error) {
    grid.innerHTML = '<div class="empty-state">We could not load these products. Use “View all” to browse the collection.</div>';
  } finally {
    panel.dataset.loading = 'false';
    grid.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', (event) => {
  const galleryThumb = event.target.closest('[data-product-gallery-thumb]');
  if (galleryThumb) {
    const gallery = galleryThumb.closest('[data-product-gallery]');
    if (!gallery) return;
    const targetId = galleryThumb.dataset.productGalleryThumb;
    gallery.querySelectorAll('[data-product-gallery-panel]').forEach((panel) => { panel.hidden = panel.dataset.productGalleryPanel !== targetId; });
    gallery.querySelectorAll('[data-product-gallery-thumb]').forEach((thumb) => {
      const active = thumb === galleryThumb;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
    return;
  }

  const minus = event.target.closest('[data-quick-qty-minus]');
  const plus = event.target.closest('[data-quick-qty-plus]');
  if (minus || plus) {
    const form = event.target.closest('[data-quick-add]');
    const input = form && form.querySelector('.product-card__qty');
    if (!input) return;
    const current = Math.max(1, Number(input.value) || 1);
    input.value = minus ? Math.max(1, current - 1) : current + 1;
    return;
  }

  const card = event.target.closest('[data-product-card-url]');
  if (card) {
    const interactive = event.target.closest('button, input, select, textarea, form, a, [role="button"]');
    if (!interactive && card.dataset.productCardUrl) {
      window.location.assign(card.dataset.productCardUrl);
      return;
    }
  }

  const tab = event.target.closest('[data-tab-target]');
  if (!tab) return;
  const container = tab.closest('[data-tabs]');
  if (!container) return;
  container.querySelectorAll('[role="tab"]').forEach((item) => {
    item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
    item.tabIndex = item === tab ? 0 : -1;
  });
  container.querySelectorAll('[role="tabpanel"]').forEach((panel) => { panel.hidden = panel.id !== tab.dataset.tabTarget; });
  const activePanel = container.querySelector('#' + CSS.escape(tab.dataset.tabTarget));
  loadLazyCollectionTab(activePanel);
});

document.addEventListener('keydown', (event) => {
  if (event.target.matches('[data-product-card-url]') && (event.key === 'Enter' || event.key === ' ')) {
    event.preventDefault();
    const url = event.target.dataset.productCardUrl;
    if (url) window.location.assign(url);
    return;
  }
  if (!event.target.matches('[data-tab-target][role="tab"]') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
  const tabs = [...event.target.closest('[role="tablist"]').querySelectorAll('[data-tab-target][role="tab"]')];
  const next = (tabs.indexOf(event.target) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
  event.preventDefault();
  tabs[next].focus();
  tabs[next].click();
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-product-variant-select]')) {
    const selected = event.target.options[event.target.selectedIndex];
    const info = event.target.closest('[data-product-info]');
    const price = info && info.querySelector('[data-product-price]');
    if (price && selected && selected.dataset.price) price.textContent = selected.dataset.price;
    return;
  }

  if (event.target.matches('[data-collection-sort]')) {
    const url = new URL(window.location.href);
    if (event.target.value) url.searchParams.set('sort_by', event.target.value);
    else url.searchParams.delete('sort_by');
    window.location.assign(url.toString());
    return;
  }

  if (event.target.matches('[data-quantity], .product-card__qty') && Number(event.target.value) < 1) event.target.value = 1;
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-quick-add-button]');
  const status = form.querySelector('[data-quick-add-status]');
  const originalText = button ? button.textContent : '';
  if (button) { button.disabled = true; button.textContent = 'Adding…'; }
  if (status) status.textContent = '';
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Unable to add item');
    const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = cartResponse.ok ? await cartResponse.json() : null;
    document.querySelectorAll('[data-cart-count]').forEach((count) => { if (cart) count.textContent = cart.item_count; });
    if (cart) document.dispatchEvent(new CustomEvent('fallingleaf:cart-updated', { detail: { cart, source: 'quick-add' } }));
    if (button) button.textContent = 'Added ✓';
    if (status) status.textContent = 'Added to cart';
    window.setTimeout(() => {
      if (button) { button.disabled = false; button.textContent = originalText || 'Add'; }
      if (status) status.textContent = '';
    }, 1400);
  } catch (error) {
    if (button) { button.disabled = false; button.textContent = originalText || 'Add'; }
    if (status) status.textContent = 'Could not add this item. Please try again.';
  }
});